import type { Position } from "@reactour/tour"
import type { ExtendedPosition } from "../types/tour.types"

/**
 * Normalize extended position values to standard @reactour/tour positions.
 * Custom positions like "topLeft" and "topRight" are mapped to their base positions.
 *
 * @param position - Extended position value
 * @returns Standard Position value for @reactour/tour
 */
export const normalizePosition = (
  position?: ExtendedPosition,
): Position | undefined => {
  if (!position) {
    return undefined
  }

  switch (position) {
    case "topLeft":
    case "topRight":
      return "top"
    case "bottomLeft":
    case "bottomRight":
      return "bottom"
    default:
      return position
  }
}

/**
 * Calculate popover margin based on tooltip position relative to highlighted element.
 * Adds step padding to margins for proper alignment.
 *
 * @param position - The tooltip position
 * @param stepPadding - Padding value from step config (default: 0)
 * @returns CSS margin string
 */
export const calculatePopoverMargin = (
  position?: ExtendedPosition,
  stepPadding = 0,
): string => {
  if (position === "right") {
    return `-${stepPadding}px 10px 10px ${15 + stepPadding}px`
  }
  if (position === "left") {
    return "0px 15px 10px -5px"
  }
  if (position === "top") {
    return "-20px 0px 15px 0px"
  }
  if (position === "bottom") {
    return `${20 + stepPadding}px 10px 15px ${0 - stepPadding}px`
  }
  if (position === "topLeft") {
    return "0px 15px 15px -5px"
  }

  return "10px 10px"
}
